import React from "react";
import { Link } from "react-router-dom";
import "./team_qualification.css";

function QualificationCards(props) {
  return (
    // <Link to={props.to}>

    <div className={props.qCardClass}>
      <img
        src={props.qCardImageSrc}
        alt="Slide 1"
        className={props.qCardImgClass}
      />
      <h6 className={props.qtitleClass}>{props.qTitle}</h6>
      <p className={props.qtextClass}>{props.qText}</p>

      {/* <button class="btn-showMore"><p>{props.btnName}</p></button> */}
      {props.btnNameCard && props.btnLinkCard && (
        <a
          href={props.btnLinkCard}
          target="_blank"
          rel="noopener noreferrer"
          className="qbutton-linkCard"
        >
          {props.btnNameCard}
        </a>
      )}
    </div>

    // </Link>
  );
}

function QualificationSection() {
  return (
    <>
      <div className="qsection-outer">
        <h6 className="q-section-title">Our Services</h6>
        <h1 className="q-section-title">How We Can Help</h1>
        <div className="qualification-section">
          <QualificationCards
            qCardClass="q-card Qcard-div-1 "
            qCardImageSrc="/images/graphicD.png"
            qCardImgClass="q-img-1"
            qTitle="Graphic Design"
            qText="Transform ideas into visual impact. Our design expertise builds brand identity that commands attention and leaves a lasting impression."
            qtitleClass="Qcard-title"
            qtextClass="Qcard-text"
          />
          <QualificationCards
            qCardClass="q-card Qcard-div-2"
            qCardImageSrc="/images/digitalM.png"
            qCardImgClass="q-img-1"
            qTitle="Digital Marketing"
            qText="Fuel your growth with a data-driven digital marketing ecosystem designed to increase visibility, engagement, and conversion across all channels."
            qtitleClass="Qcard-title"
            qtextClass="Qcard-text"
          />
          <QualificationCards
            qCardClass="q-card Qcard-div-3 "
            qCardImageSrc="/images/contentCreation.png"
            qCardImgClass="q-img-1"
            qTitle="Content Creation"
            qText="Crafted by creative professionals, our content delivers compelling stories tailored for every platform to amplify your brand voice and drive action."
            qtitleClass="Qcard-title"
            qtextClass="Qcard-text"
          />

          <QualificationCards
            qCardClass="q-card Qcard-div-4 "
            qCardImageSrc="/images/seo.png"
            qCardImgClass="q-img-1"
            qTitle="SEO Consult"
            qText="Climb search ranks with strategic techniques. Enhance visibility and performance."
            // Get expert guidance on climbing search engine ranks. We develop strategies that boost discoverability, traffic, and long-term digital performance.
            qtitleClass="Qcard-title"
            qtextClass="Qcard-text"
            btnNameCard="Book Now!"
            btnLinkCard="https://tidycal.com/michaeldimasciomedia/seo-consultation"
          />

          <QualificationCards
            qCardClass="q-card Qcard-div-5 "
            qCardImageSrc="/images/mic.png"
            qCardImgClass="q-img-1"
            qTitle="Voice Over"
            qText="Deliver your message with power and clarity. Michael's professional voice talent brings stories to life with tone, emotion, and precision."
            // Turn messages into captivating narratives with our pros. Engage through commercials & more.
            qtitleClass="Qcard-title"
            qtextClass="Qcard-text"
          />
          <QualificationCards
            qCardClass="q-card Qcard-div-6 "
            qCardImageSrc="/images/drone.png"
            qCardImgClass="q-img-1"
            qTitle="Drone Filming"
            qText="Capture breathtaking aerial perspectives. Operated by licensed professionals, our drone service elevates storytelling with cinematic impact."
            qtitleClass="Qcard-title"
            qtextClass="Qcard-text"
          />
        </div>
        <Link to={"/Booking"} className="qbutton-link">
          <button className="qbutton">Learn More</button>
        </Link>
      </div>
    </>
  );
}

export { QualificationSection };
